import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d72298c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = { href: "https://getindya.com/" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://getindya.com/suscripcion/" }, "Suscripción")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://getindya.com/app/" }, "App")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://getindya.com/nutricionistas/" }, "Nutricionistas")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://getindya.com/testimonios/" }, "Testimonios")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://getindya.com/historia/" }, "Historia")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://getindya.com/blog/" }, "Blog")
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://getindya.com/terminos-y-condiciones/" }, "Términos y condiciones")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://getindya.com/aviso-legal/" }, "Aviso Legal")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://getindya.com/utilizacion-cookies/" }, "Utilización de Cookies")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://getindya.com/proteccion-de-datos-gdpr/" }, "Protección de datos GDPR")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://getindya.com/consentimiento-informado/" }, "Concentimiento Informado")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://getindya.com/antidopping/" }, "Anti dopping")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://getindya.com/menores/" }, "Menores")
  ])
], -1))
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Column, null, {
        content: _withCtx(() => [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("img", {
                alt: "phone",
                src: require('@/assets/images/phone.png')
              }, null, 8, _hoisted_5),
              _createTextVNode(" 685 489 604 - L a V de 8 a 20 h. ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("img", {
                alt: "email",
                src: require('@/assets/images/email-inverted.png')
              }, null, 8, _hoisted_6),
              _createTextVNode(" contacto@getindya.com ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("img", {
                alt: "dirección",
                src: require('@/assets/images/pin.png')
              }, null, 8, _hoisted_7),
              _createTextVNode(" C/ San Vicente Mártir, 128 46007 València (España) ")
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("a", _hoisted_3, [
            _createElementVNode("img", {
              src: require('@/assets/images/logo.svg'),
              alt: "logo",
              width: "93"
            }, null, 8, _hoisted_4)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Column, null, {
        content: _withCtx(() => [
          _hoisted_8
        ]),
        default: _withCtx(() => [
          _createTextVNode(" SECCIONES ")
        ]),
        _: 1
      }),
      _createVNode(_component_Column, null, {
        content: _withCtx(() => [
          _hoisted_9
        ]),
        default: _withCtx(() => [
          _createTextVNode(" TODO EN ORDEN ")
        ]),
        _: 1
      }),
      _createVNode(_component_Column, { class: "center" }, {
        content: _withCtx(() => [
          _createElementVNode("img", {
            alt: "Institut Valencià de Finances",
            src: require('@/assets/images/IVF.png')
          }, null, 8, _hoisted_10),
          _createElementVNode("img", {
            alt: "Generalitat Valenciana",
            src: require('@/assets/images/GV.png')
          }, null, 8, _hoisted_11),
          _createElementVNode("img", {
            alt: "Instituto Valenciano de Competitividad Empresarial",
            src: require('@/assets/images/IVACE.png')
          }, null, 8, _hoisted_12),
          _createElementVNode("img", {
            alt: "Unión Europea",
            src: require('@/assets/images/UE.png')
          }, null, 8, _hoisted_13)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" Plataforma inteligente para la planificación nutricional de deportistas ")
        ]),
        _: 1
      })
    ])
  ]))
}